export default "__VITE_ASSET__J1FHkhqg__"